<!-- 商品兑换 -->
<template>
  <div class="component-page">
    <div class="goods-tabs">
      <div class="tabs-left">
        <!-- <strong>商品分类</strong> -->
        <ul>
          <li v-for="tabItem in goodsCategory.list" :key="tabItem.value" :class="{
              tabItem: 1,
              active: tabItem.value === goodsCategory.value,
            }" @click="methodChangeGoodsCate(tabItem.value)">
            {{ tabItem.label }}
          </li>
        </ul>
      </div>
      <div class="tabs-right">
        <strong>筛选</strong>
        <el-radio-group v-model="recentOrHot" size="mini" @input="methodChangeGoodsFilter">
          <el-radio-button label="hot">
            <span class="btn-content">
              <img v-if="recentOrHot !== 'hot'" class="hot" src="@/assets/image/stuUI/hot@2x.png" alt="" />
              <img v-else class="hot" src="@/assets/image/stuUI/hotActive@2x.png" alt="" />
              最热
            </span>
          </el-radio-button>
          <el-radio-button label="recent">
            <span class="btn-content">
              <img v-if="recentOrHot !== 'recent'" class="new" src="@/assets/image/stuUI/new@2x.png" alt="" />
              <img v-else class="new" src="@/assets/image/stuUI/newActive@2x.png" alt="" />
              最新
            </span>
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-row :gutter="20" v-if="tableData.join('') !== ''">
      <el-col :span="5" v-for="colItem in tableData" :key="colItem.id">
        <div class="col-div">
          <div class="goods-img">
            <div class="goods-img-box">
              <img :src="colItem.highPictureUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
              <!-- <img
                :src="require('@/assets/image/starCoin/cardIcon1@2x.png')"
                alt=""
              /> -->
            </div>
          </div>
          <div class="goods-info">
            <div class="name" :title="colItem.name">
              {{ colItem.name }}
            </div>
            <div class="surplus">
              商品剩余数量 {{ colItem.inventory }}
              <span class="goods-sort">{{ colItem.categoryLabel }}</span>
            </div>
            <!-- 兑换进度 -->
            <div class="exchange-progress">
              <div class="progress-bar" :style="{
                  '--before-width': progressVal(colItem) + '%',
                }"></div>
              <div class="progress-text" :style="{ color: colItem.state === 2 ? '#666' : '#FD8003' }">
                {{
                  colItem.state === 3
                    ? '差' + diffPrice(colItem)
                    : stateMap[colItem.state]
                }}
              </div>
            </div>
            <div class="btns">
              <div class="price">
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <strong>{{ colItem.starNum }}</strong>
              </div>
              <button :class="{
                  btn: 1,
                  primary: colItem.state === 0,
                  lacking: colItem.state === 3,
                  soldOut: colItem.state !== 0 && colItem.state !== 3,
                  owned: colItem.state === 4,
                }" @click="methodExchangeDialog(colItem)" :disabled="colItem.state !== 0">
                {{ stateMap[colItem.state] }}
              </button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty v-else description="暂无数据"></el-empty>
    <el-dialog title="" :visible.sync="exchangeDialog" width="680px">
      <div class="exchange-info" v-if="exchangeInfo">
        <div class="left">
          <img :src="exchangeInfo.highPictureUrl" alt="" ondragstart="return false" oncontextmenu="return false" />
        </div>
        <div class="right">
          <div class="title">{{ exchangeInfo.name }}</div>
          <div class="order">商品编号：{{ exchangeInfo.productNumber }}</div>
          <div class="price">
            单价：{{ exchangeInfo.starNum }} <span>星币</span>
          </div>
          <div class="num">
            数量：<el-input-number :disabled="exchangeInfo.category !== 2" v-model="exchangeInfo.exchangeNum" :min="1" :max="exchangeInfo.inventory" step-strictly label="数量" size="mini"></el-input-number>
            <!-- @change="handleChange" -->
          </div>
          <div class="type" v-if="exchangeInfo.category === 2">
            兑换方式去机构找老师领取
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="exchangeInfo">
        <div class="practical">
          实际支付：<span><strong>{{ calcTotal(exchangeInfo) }}</strong> 星币</span>
        </div>
        <el-button type="primary" @click="stuOrderExchange">立即兑换</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="confirmExchange" width="30%">
      <div>你已经拥有了此物品，确定要再次兑换吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmExchange = false">取消</el-button>
        <el-button type="primary" @click="methodConfirmExchange">再次兑换</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// API
import { api_stuProductRedeemList, api_stuOrderExchange } from '@/api/javaApi'
export default {
  name: 'goodsExchange',
  props: ['pageInfo', 'myStarNum'],
  data() {
    return {
      goodsCategory: {
        value: null,
        list: [
          { label: '全部', value: null },
          { label: '头像', value: 3 },
          { label: '挂件', value: 1 },
          { label: '伴学精灵', value: 0 },
          { label: '实物商品', value: 2 },
        ],
      },
      recentOrHot: 'recent',
      tableData: [],
      exchangeDialog: false,
      exchangeInfo: null,
      confirmExchange: false,
      firstRequest: true,
      stateMap: {
        0: '立即兑换',
        1: '兑换中',
        2: '售罄',
        3: '星币不足',
        4: '已拥有',
      },
    }
  },
  computed: {
    calcPageInfo() {
      return window.JSON.stringify(this.pageInfo)
    },
    diffPrice() {
      return function (colItem) {
        const diffVal = colItem.starNum - this.myStarNum
        if (diffVal > 0) {
          // 钱不够
          return diffVal
        } else {
          return 0
        }
      }
    },
    // 兑换总价
    calcTotal: {
      get() {
        return function (exchangeInfo) {
          return exchangeInfo.starNum * exchangeInfo.exchangeNum
        }
      },
    },
    // 进度条
    progressVal() {
      return function (colItem) {
        if (colItem.inventory === 0) {
          return 0
        }
        const diffVal = colItem.starNum * this.myStarNum
        if (diffVal > 0) {
          // 钱不够
          return (diffVal / colItem.starNum) * 100
        } else {
          return 100
        }
      }
    },
  },
  watch: {
    // 直接监听prop新旧值一样，因为是引用类型，所以用计算属性包裹一下变成字符串
    calcPageInfo: {
      handler(newPage, oldPage) {
        // console.log('newPage:', newPage)
        // console.log('oldPage:', oldPage)
        if (oldPage !== newPage && window.JSON.parse(newPage).update) {
          this.stuProductRedeemList()
        }
      },
    },
  },
  created() {
    this.stuProductRedeemList()
  },
  methods: {
    methodChangeGoodsCate(active) {
      this.$parent.page.currentPage = 1
      this.goodsCategory.value = active
      this.stuProductRedeemList()
    },
    methodChangeGoodsFilter() {
      this.$parent.page.currentPage = 1
      this.stuProductRedeemList()
    },
    // 星币中心 商品兑换列表
    stuProductRedeemList() {
      api_stuProductRedeemList({
        currentStarNum: this.myStarNum,
        stuId: this.$store.state.user.userInfo.id,
        eduCampusId: this.$store.state.user.userInfo.eduCampusId,
        recent: this.recentOrHot === 'recent',
        hot: this.recentOrHot === 'hot',
        category: this.goodsCategory.value,
        pageRequest: {
          pageNum: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize,
        },
      }).then((res) => {
        console.log(res)
        res.content.forEach((item) => {
          item.highPictureUrl =
            this.$store.state.resource.picBaseUrl + item.highPictureUrl
          item.categoryLabel =
            item.category === 0
              ? '伴学精灵'
              : item.category === 1
                ? '头像挂件'
                : item.category === 2
                  ? '实物'
                  : '头像'
        })
        this.tableData = res.content
        this.$emit('returnPage', {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
          update: false,
        })
        this.firstRequest = false
      })
    },
    methodExchangeDialog(row) {
      this.exchangeInfo = row
      this.exchangeInfo.exchangeNum = 1
      if (row.state === 4) {
        this.confirmExchange = true
      } else {
        this.exchangeDialog = true
      }
    },
    methodConfirmExchange() {
      if (this.exchangeInfo) {
        this.confirmExchange = false
        this.exchangeDialog = true
      }
    },
    stuOrderExchange() {
      if (this.calcTotal(this.exchangeInfo) > this.myStarNum) {
        return this.$message.warning('你的星币不足，无法兑换，请修改数量')
      }
      api_stuOrderExchange({
        productId: this.exchangeInfo.id, // 产品ID
        exchangeNum: this.exchangeInfo.exchangeNum, // 兑换数量
        consumeStarNum:
          this.exchangeInfo.exchangeNum * this.exchangeInfo.starNum, // 消耗星币
        productCategory: this.exchangeInfo.category, // 产品类型
        eduCampusId: this.exchangeInfo.eduCampusId, // 学校ID
        stuId: this.$store.state.user.userInfo.id, // 学生ID
        stuName: this.$store.state.user.userInfo.stuUserInfo.realName, // 学员姓名
      }).then((res) => {
        console.log(res)
        this.$message.success(res)
        this.exchangeDialog = false
        this.stuProductRedeemList()
        this.$parent.stuStuStarPersonalSoa()
      })
    },
  },
}
</script>
<style scoped lang="scss">
.component-page {
  .goods-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 10px;
    padding: 0 40px;
    background: #ffffff;
    border-radius: 10px;
    font-size: 14px;
    .tabs-left {
      display: flex;
      align-items: center;
      strong {
        margin-right: 60px;
      }
      ul {
        display: flex;
        align-items: center;
        li.tabItem {
          position: relative;
          display: inline-flex;
          align-items: center;
          height: 45px;
          margin-right: 60px;
          transition: all 0.25s;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            width: 0px;
            height: 3px;
            background: #1678ff;
            border-radius: 3px;
            transition: width 0.15s;
          }
          &:hover {
            color: #1578ff;
          }
          &.active {
            color: #1578ff;
            font-weight: bold;
            &::after {
              width: 35px;
            }
          }
        }
      }
    }
    .tabs-right {
      display: flex;
      align-items: center;
      strong {
        margin-right: 30px;
      }
      .btn-content {
        position: relative;
        display: inline-flex;
        align-items: center;
        padding-left: 30px;
        font-size: 14px;
        img {
          position: absolute;
          &.hot {
            left: 5px;
            width: 15px;
            margin-right: 10px;
          }
          &.new {
            left: 0;
            width: 25px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .el-row {
    .el-col {
      width: 20%;
    }
  }
  .col-div {
    position: relative;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 10px;
    transition: box-shadow 0.2s;
    overflow: hidden;
    &::before {
      position: absolute;
      left: -1px;
      top: -1px;
      width: 100%;
      height: 100%;
      content: "";
      display: block;
      border-radius: 10px;
      border: 1px solid transparent;
      transition: border-color 0.2s;
      pointer-events: none;
    }
    &:hover {
      box-shadow: 1px 0px 4px 0px #7591b8;
      &::before {
        border-color: #1678ff;
      }
    }
    .goods-img {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 220px;
      padding: 10px;
      .goods-img-box {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        // padding: 15px;
        // background-color: #f0f0f0;
        border-radius: 10px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          max-height: 100%;
          border-radius: 10px;
          object-fit: cover;
        }
      }
    }
    .goods-info {
      padding: 0px 25px 15px;

      .name {
        padding-bottom: 5px;
        font-weight: 400;
        font-size: 14px;
        font-weight: bold;
        color: #0a1629;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .surplus {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        .goods-sort {
          padding-left: 15px;
          color: #1678ff;
        }
      }
      .exchange-progress {
        display: flex;
        align-items: center;
        padding-bottom: 12px;
        .progress-bar {
          flex: 1;
          position: relative;
          height: 5px;
          margin-right: 10px;
          background: #dedede;
          border-radius: 3px;
          overflow: hidden;
          &::before {
            position: absolute;
            content: "";
            width: var(--before-width);
            height: 100%;
            left: 0;
            top: 0;
            background-color: #fd8003;
            transition: width 0.15s;
          }
        }
        .progress-text {
          flex-shrink: 0;
          font-weight: 400;
          font-size: 12px;
          color: #fd8003;
        }
      }
      .btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .price {
          display: inline-flex;
          align-items: center;
          img {
            display: block;
            width: 16px;
          }
          strong {
            padding-left: 5px;
            color: #333;
            font-size: 18px;
          }
        }
        .btn {
          outline: none;
          border: none;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          height: 26px;
          padding: 0 14px;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          border-radius: 50px;
          transition: all 0.25s;
          &.primary {
            cursor: pointer;
            background: #1678ff;
          }
          &.owned {
            background: #1678ff;
          }
          &.lacking {
            background: #dcecff;
            color: #7b91b0;
          }
          &.soldOut {
            background: #e6e6e6;
            color: #acacac;
          }
        }
      }
    }
  }
  .el-dialog {
    .exchange-info {
      display: flex;
      padding: 0 20px 30px;
      border-bottom: 1px solid #f5f5f5;
      .left {
        flex-shrink: 0;
        width: 165px;
        height: 165px;
        margin-right: 25px;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .right {
        flex: 1;
        .title {
          padding-bottom: 10px;
          font-weight: 500;
          font-size: 16px;
          color: #0a1629;
        }
        .order {
          padding-bottom: 10px;
          font-weight: 400;
          font-size: 14px;
          color: #0a1629;
        }
        .price {
          padding-bottom: 10px;
          font-weight: 600;
          font-size: 18px;
          color: #1678ff;
          span {
            font-weight: 400;
            font-size: 14px;
          }
        }
        .num {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
        .type {
          padding-top: 15px;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
        }
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      .practical {
        display: inline-flex;
        align-items: center;
        margin-right: 40px;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        span {
          color: #1678ff;
          strong {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
